import { Button } from '@synoptic/ui-kit/button/button.js';
import { SynopticLogoCompactIcon } from '@synoptic/ui-kit/icons/react/synoptic-logo-compact.js';
import { SynopticLogoIcon } from '@synoptic/ui-kit/icons/react/synoptic-logo.js';
import { LinkButton } from '@synoptic/ui-kit/link-button/link-button.js';
import { useIsLaptop } from '@synoptic/ui-kit/responsive/hooks.js';
import { ThemeProvider } from '@synoptic/ui-kit/theme/theme-provider.js';
import { QueryClientProvider } from '@tanstack/react-query';
import { Outlet } from 'react-router';
import { FullscreenPage } from '@/components/layout/fullscreen-page';
import { queryClient } from '@/react-query/react-query-instance';
import { Link, NavLink } from '@/routes-utils/navigation';
import { paths } from '@/routes-utils/paths';
import { StarsSvg } from './stars';
import {
  ctWrapped,
  ctWrappedContainer,
  ctWrappedHeader,
  ctWrappedSearchByUsernameButton,
  ctWrappedStars,
} from './route.css';

const Logo = () => {
  const isLaptop = useIsLaptop();
  return isLaptop ? <SynopticLogoIcon /> : <SynopticLogoCompactIcon />;
};

export default function CtWrappedRoute() {
  return (
    <ThemeProvider mode="dark">
      <QueryClientProvider client={queryClient}>
        <FullscreenPage className={ctWrappedContainer}>
          <div className={ctWrapped}>
            <StarsSvg className={ctWrappedStars} />

            <div className={ctWrappedHeader}>
              <Link
                style={{ display: 'inline-flex' }}
                to={paths.ctStats}
                viewTransition
                prefetch="render"
              >
                <Logo />
              </Link>

              <LinkButton
                size="medium"
                className={ctWrappedSearchByUsernameButton}
                asChild
              >
                <NavLink to={paths.ctStats} viewTransition end>
                  Search by username
                </NavLink>
              </LinkButton>

              <Button variant="ghost" asChild>
                <Link to={paths.landing}>Go to marketplace</Link>
              </Button>
            </div>

            <Outlet />
          </div>
        </FullscreenPage>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
